import "owl.carousel"
import "./juicer"
import 'magnific-popup'

jQuery(document).ready(function ($) {

  $("#instagram-feed").juicer()

  $.magnificPopup.open({
    items: {
      src: '#popup',
      type: 'inline'
    }
  });


  function createMusicCarousel() {
    const musicCarousel = $("#music-carousel")
    const leftArrow = '<div class="owl-custom-nav-prev arrow"><i class="fa-solid fa-chevron-left"></i></div>'
    const rightArrow = '<div class="owl-custom-nav-next arrow"><i class="fa-solid fa-chevron-right"></i></div>'

    musicCarousel.owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      items: 3,
      startPosition: 1,
      autoplayTimeout: 3000,
      autoplaySpeed: 500,
      margin: 20,
      center: true,
      responsive: {
        0: {
          items: 2.5,
          margin: 0
        },
        700: {
          items: 3,
        }
      },
      navText: [
        leftArrow,
        rightArrow
      ]
    })
  }
  createMusicCarousel()

  function createVideoCarousel() {
    const videoCarousel = $("#video-carousel")
    const leftArrow = '<div class="owl-custom-nav-prev arrow"><i class="fa-solid fa-chevron-left"></i></div>'
    const rightArrow = '<div class="owl-custom-nav-next arrow"><i class="fa-solid fa-chevron-right"></i></div>'

    videoCarousel.owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      items: 3,
      startPosition: 1,
      autoplayTimeout: 3000,
      autoplaySpeed: 500,
      // margin: 24,
      center: true,
      responsive: {
        0: {
          items: 1.5,
        },
        700: {
          items: 2,
        }
      },
      navText: [
        leftArrow,
        rightArrow
      ]
    })
  }
  createVideoCarousel()

  // Remove invalid role attributes
  $('.owl-prev, .owl-next').removeAttr('role');

  // Optionally, add correct role/aria if needed
  $('.owl-prev').attr('aria-label', 'Previous slide');
  $('.owl-next').attr('aria-label', 'Next slide');

});